module.exports = __webpack_public_path__ + "static/media/iitb_logo.4873d752.png";